import { ProjectModel } from "@app/catalog";

export class ExportPackageMessage {
    public project: ProjectModel 

    constructor(project: ProjectModel) {
        if (project !== undefined)
            {
                this.project = project;
            }
    }
}